import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  FaCheckCircle, 
  FaMapMarkerAlt, 
  FaHome, 
  FaCar, 
  FaTint, 
  FaCalendarAlt,
  FaClock,
  FaIdCard,
  FaGasPump,
  FaRegCheckCircle,
  FaPrint,
  FaTimes,
  FaReceipt
} from 'react-icons/fa';
import { MdVerified, MdLocationOn } from 'react-icons/md';
import '../../styles/Conclusao.css';
import '../../styles/CupomFiscalModal.css';
import CupomFiscalModal from '../../components/CupomFiscalModal';

const ConclusaoScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [solicitacao, setSolicitacao] = useState(null);
  const [animationComplete, setAnimationComplete] = useState(false);
  const [showCupomModal, setShowCupomModal] = useState(false);
  
  // Pega parâmetros da URL
  const searchParams = new URLSearchParams(location.search);
  const litros = searchParams.get('litros');
  const dadosParam = searchParams.get('dados');
  const dataHoraParam = searchParams.get('dataHora');
  
  // Dados do usuário
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const posto = user?.posto || {
    nome: 'Posto não informado',
    endereco: 'Endereço não informado'
  };

  useEffect(() => {
    if (dadosParam) {
      try {
        const parsed = JSON.parse(decodeURIComponent(dadosParam));
        setSolicitacao(parsed);
      } catch (e) {
        console.error('Erro ao parsear dados:', e);
      }
    }
    
    // Animação de entrada
    const timer = setTimeout(() => setAnimationComplete(true), 500);
    return () => clearTimeout(timer);
  }, [dadosParam]);

  const formatarDataHora = () => {
    if (dataHoraParam) return dataHoraParam;
    const agora = new Date();
    return agora.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const handleVoltarInicio = () => {
    navigate('/');
  };

  const handleAbrirCupom = () => {
    setShowCupomModal(true);
  };

  const handleFecharCupom = () => {
    setShowCupomModal(false);
  };

  const handleImprimirCupom = () => {
    window.print();
  };

  // Lista de confirmações
  const confirmacoes = [
    { icon: <FaCheckCircle />, text: 'Abastecimento registrado com sucesso', color: '#22C55E' },
    { icon: <FaMapMarkerAlt />, text: 'Geolocalização registrada', color: '#1A4FA0' },
    { icon: <FaRegCheckCircle />, text: 'Registro disponível no histórico', color: '#F5A623' },
  ];

  return (
    <div className="conclusao-web">
      <div className="conclusao-card">
        {/* Header de sucesso */}
        <div className="conclusao-header-web">
          <div className="success-animation">
            <div className="success-circle">
              <FaCheckCircle className="success-icon" />
            </div>
            <div className="success-ring"></div>
          </div>
          <h1 className="success-title">
            Abastecimento<br />Concluído!
          </h1>
          <p className="success-subtitle">
            Operação realizada com sucesso
          </p>
        </div>

        {/* Corpo com informações */}
        <div className="conclusao-body-web">
          {/* Card de Resumo */}
          <div className="resumo-card">
            <h3 className="resumo-title">
              <FaGasPump className="title-icon" />
              Resumo do Abastecimento
            </h3>

            {/* Informações do Posto */}
            <div className="posto-info-web">
              <div className="posto-icon-web">
                <FaMapMarkerAlt />
              </div>
              <div className="posto-detalhes-web">
                <span className="posto-label-web">Posto</span>
                <p className="posto-nome-web">{posto?.nome || 'Posto não informado'}</p>
                <p className="posto-endereco-web">{posto?.endereco || 'Endereço não informado'}</p>
              </div>
            </div>

            <hr className="divisor-web" />

            {/* informações do veículo */}
            <div className="info-grid-web">
              <div className="info-card-item">
                <FaCar className="info-card-icon" />
                <div>
                  <span className="info-card-label">Placa</span>
                  <p className="info-card-value">{solicitacao?.veiculo?.placa || '-'}</p>
                </div>
              </div>
              <div className="info-card-item">
                <FaIdCard className="info-card-icon" />
                <div>
                  <span className="info-card-label">Veículo</span>
                  <p className="info-card-value" title={solicitacao?.veiculo?.descricao}>
                    {solicitacao?.veiculo?.descricao || '-'}
                  </p>
                </div>
              </div>
            </div>

            {/* Litros */}
            <div className="info-card-item full-width">
              <FaTint className="info-card-icon" />
              <div>
                <span className="info-card-label">Quantidade</span>
                <p className="info-card-value highlight">
                  {litros ? `${parseFloat(litros).toFixed(3)} Litros` : '0 L'}
                </p>
              </div>
            </div>

            {/* Data e Hora */}
            <div className="info-card-item full-width">
              <div className="date-time-group">
                <div className="date-time-item">
                  <FaCalendarAlt className="info-card-icon" />
                  <div>
                    <span className="info-card-label">Data</span>
                    <p className="info-card-value">{formatarDataHora().split(' ')[0]}</p>
                  </div>
                </div>
                <div className="date-time-item">
                  <FaClock className="info-card-icon" />
                  <div>
                    <span className="info-card-label">Hora</span>
                    <p className="info-card-value">{formatarDataHora().split(' ')[1]}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Lista de confirmações */}
          <div className="confirmacoes-web">
            {confirmacoes.map((item, index) => (
              <div 
                key={index} 
                className={`confirmacao-item-web ${animationComplete ? 'animated' : ''}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="confirmacao-icon" style={{ color: item.color }}>
                  {item.icon}
                </div>
                <span className="confirmacao-texto-web">{item.text}</span>
              </div>
            ))}
          </div>

          {/* Botão voltar ao início */}
          <button className="btn-voltar-web" onClick={handleVoltarInicio}>
            <FaHome />
            <span>Voltar ao Início</span>
          </button>
          <button className="btn-cupom-web" onClick={handleAbrirCupom}>
            <FaReceipt />
            <span>Ver Comprovante</span>
          </button>

          {/* ID do Abastecimento */}
          <div className="id-abastecimento-web">
            <span className="id-label">ID do Abastecimento</span>
            <strong className="id-value">
              #{solicitacao?.id?.toString().padStart(6, '0') || '000000'}
            </strong>
          </div>
        </div>
        <CupomFiscalModal
          show={showCupomModal}
          onClose={handleFecharCupom}
          onPrint={handleImprimirCupom}
          dados={{ litros, solicitacao, posto, precoLitro: solicitacao?.total || 0, user: user }}
        />
      </div>
    </div>
  );
};

export default ConclusaoScreen;